<ng-container *ngIf="!hasInfo">
  <h2 mat-dialog-title>Nessuna infomazione ricevuta
    <button mat-icon-button class="close-button" [mat-dialog-close]="true">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
</ng-container>

<ng-container *ngIf="hasInfo">
  <h2 mat-dialog-title>Informazioni ricevute
    <button mat-icon-button class="close-button" [mat-dialog-close]="true">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <div mat-dialog-content>
    <div class="rawValueContainer">

      <mat-form-field appearance="outline" style="width:100%">
        <mat-label>Filtra</mat-label>
        <input validatorColor matInput [formControl]="filterForm" #search>
      </mat-form-field>

      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

        <ng-container matColumnDef="label">
          <th mat-header-cell *matHeaderCellDef> Chiave </th>
          <td mat-cell *matCellDef="let element">
            <span class="cellValue">{{element.description}}</span>
            <button mat-icon-button *ngIf="element.description.trim() != ''" [cdkCopyToClipboard]="element.description"
              (cdkCopyToClipboardCopied)="onClipboardCopy($event)">
              <mat-icon>content_copy</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef> Valore </th>
          <td mat-cell *matCellDef="let element">
            <span class="cellValue">{{element.value}}</span>
            <button *ngIf="element.value.trim() != ''" mat-icon-button [cdkCopyToClipboard]="element.value"
              (cdkCopyToClipboardCopied)="onClipboardCopy($event)">
              <mat-icon>content_copy</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="2">Nessun risultato per "{{search.value}}"</td>
        </tr>
      </table>

    </div>
  </div>
</ng-container>
